import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import {
  getPersonalPointsStatement,
  downloadPoints
} from '../../actions/points-statement';
import PersonalRewardsStatementList from './personal-rewards-statement-list';
import Filter from './filter';

class PersonalRewardsStatement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 1,
      filters: {}
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(getPersonalPointsStatement());
  }

  handlePageChange = page => this.setState({pageNumber: page}, this.handleSearch);

  handleSearch = () => {
    const { pageNumber, filters } = this.state;

    this.props.dispatch(getPersonalPointsStatement(pageNumber, filters));
  };

  applyFilters = (filters) => {
    const { dispatch } = this.props;
    const { pageNumber } = this.state;

    dispatch(getPersonalPointsStatement(pageNumber, filters));
    this.setState({ filters });
  }

  download = () => {
    downloadPoints('personal');
  }

  render() {
    const { stores } = this.props;

    return (
      <div>
        <Row>
          <Col className="points-statement-tabs-personal-filter" xs={12}>
            <Filter
              stores={stores}
              applyFilters={this.applyFilters}
              download={this.download}
            />
          </Col>
        </Row>
        <Row>
          <Col className="points-statement-tabs-personal-list" md={12}>
            <PersonalRewardsStatementList
              points_statement={this.props.points_statements}
              fetching={this.props.fetching}
              fetched={this.props.fetched}
              pagination={this.props.pagination}
              onPageChange={this.handlePageChange}
              currentPage={this.state.pageNumber}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  stores: state.points_statement.outlets,
  points_statements: state.points_statement.personalList,
  pagination: state.points_statement.personalListPaging,
  fetching: state.points_statement.fetching,
  fetched: state.points_statement.fetched
});

export default connect(mapStateToProps)(PersonalRewardsStatement);
